import { safeJson } from "src/app/helpers/Index";
import { faPencil, faPeopleGroup, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ResizeImage } from "src/app/helpers/ResizeImage";
import { Col, Nav, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { ServiceContract, ServiceContractFile, Sponsor } from "src/app/interfaces/Index";
import { FileService, ServiceContractService, SponsorService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./AdminServiceContracts.css";
import { TabView, TabPanel } from "primereact/tabview";
import { Calendar } from "primereact/calendar";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	masterItems: ServiceContract[];
	items: ServiceContract[];
	selectedItem: ServiceContract;
	selectedItemFiles: ServiceContractFile[];
	selectedItems: ServiceContract[];
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	showPlayers: boolean;
	sponsors: Sponsor[];
	submitted: boolean;
};

export class AdminServiceContracts extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Service Contract";
	itemNamePlural: string = "Service Contracts";

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", masterItems: [], selectedItem: new ServiceContract(),selectedItemFiles: [], selectedItems: [], items: [], showDeleteModal: false, showDeleteSelectionModal: false, showItemInfoModal: false, showPlayers:false, sponsors: [], submitted: false};
	}

	categoryChange(e: any) {
		let selectedItem = {...this.state.selectedItem};
		// selectedItem.type = e.value;
		this.setState({selectedItem});
	}

	componentDidMount() {
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteSelectionModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm(rowData: any) {
		const res = await (await ServiceContractService.deleteSingleById(this.state.selectedItem.id));
		console.log(res)
		if (!res.ok) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
		}
		this.toast.show({closable: false, detail: "ServiceContract has been deleted", life: 5000, severity: "warn", summary: "Service Contract deleted!"});
		this.getItems();
		this.setState({showDeleteModal: false});
	}

	deleteSelectedItemConfirm() {}

	itemInfoFooter() {
			return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new ServiceContract(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
			);
	}

	globalFilterChange(e: any) {
		let value = ""
		if (e !== ""){
			value = e.target.value;
			let newData = this.state.masterItems.filter(function(item){
				return item.serviceProvider?.toLowerCase().includes(value.toLowerCase()) || item.description?.toLowerCase().includes(value.toLowerCase());
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await safeJson(ServiceContractService.getAll());
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
		this.setState({isLoading: false, items: res, masterItems:res});
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new ServiceContract({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new ServiceContract({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({selectedItems: e.value})} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items}>
								<Column field="serviceProvier" header="Provider" sortable ></Column>
								<Column style={{width: 75,float:"right"}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true, selectedItemFiles: JSON.parse(rowData.relatedFiles)})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
							<TabView className="tabview-header-icon">
									<TabPanel header="Key Information" leftIcon="pi pi-info-circle">
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="serviceProvider"> Service Provider</label>
													<InputText id="serviceProvider" value={this.state.selectedItem.serviceProvider} onChange={(e) => this.inputChange(e, "serviceProvider")}/>
												</div>
											</Col>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="noticePeriod">Notice Period</label>
													<InputNumber id="noticePeriod" value={this.state.selectedItem.noticePeriod} onChange={(e) => this.inputNumberChange(e, "noticePeriod")}/>
												</div>
											</Col>
										</Row>
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="description">Description</label>
													<InputText id="description" value={this.state.selectedItem.description} onChange={(e) => this.inputChange(e, "description")}/>
												</div>
											</Col>
										</Row>
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="effectiveDate"> Effective Date</label>
													<Calendar id="effectiveDate" value={this.state.selectedItem.effectiveDate} onChange={(e) => this.inputChange(e, "effectiveDate")}/>
												</div>
											</Col>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="endDate">End Date</label>
													<Calendar id="endDate" value={this.state.selectedItem.endDate} onChange={(e) => this.inputChange(e, "endDate")}/>
												</div>
											</Col>
										</Row>
										</TabPanel>
										<TabPanel header="Files" leftIcon="pi pi-file">
										<Row>
										<Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="mugshotUrl" style={{ width: "100%" }}>Player Image</label>
													{/* <img id="mugshotUrl" src={this.state.selectedItem.mugshotUrl} style={{ height: 90, marginBottom: 10, marginTop: 10 }}></img> */}
												</div>
											</Col>
											<Col xs={5}>
										<FileUpload auto customUpload name="mugshotUrl" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "mugshotUrl")} mode="basic"></FileUpload>
										</Col>
										</Col>
										</Row>
										<Row>
											<Col>
												<label style={{marginTop: ".5rem", marginBottom: "1rem"}} htmlFor="orderItems">Itemised Breakdown</label>
												<DataTable id="selectedItemFiles" scrollable scrollHeight="350px" style={{marginBottom: 10}} value={this.state.selectedItemFiles}>
													<Column field="dateUploaded" header="Uploaded" sortable></Column>
													<Column field="name" header="Item" sortable></Column>
												</DataTable>
											</Col>
										</Row>
										</TabPanel>
										</TabView>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Dialog footer={() => this.deleteItemFooter()} header="Confirm" modal onHide={() => this.setState({showDeleteModal: false})} style={{width: 550}} visible={this.state.showDeleteModal}>
					<div className="d-flex align-items-center justify-content-center">
						<i className="pi pi-exclamation-triangle mr-3" style={{fontSize: "2rem", marginRight: "0.5rem"}}/>
						{this.state.selectedItem &&
							<span>Are you sure you want to delete contract with <b>{this.state.selectedItem.serviceProvider}</b>?</span>
						}
					</div>
				</Dialog>
				<Toast ref={(el) => this.toast = el}></Toast>
				{this.state.showPlayers && (
								<Navigate replace={true} to={`/${environment.build.adminRoute}/ServiceContract-players/${this.state.selectedItem.id}`} />
				)}
			</>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10}} onClick={() => this.setState({selectedItem: new ServiceContract(), showItemInfoModal: true})}></Button>
				{/* <Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button> */}
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-upload" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt.exportCSV()}></Button>
			</>
		);
	}

	async saveItem() {
		this.setState({isLoading: true});
		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			
			const res = await safeJson(ServiceContractService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
		} else { // Save existing
			const res = await safeJson(ServiceContractService.updateSingleById(this.state.selectedItem.id,this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
		}
		this.getItems();
	}

	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		console.log(data.files);
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Files");
		const response = await(await FileService.upload(uploadData)).json();

		let newFile = new ServiceContractFile();
		newFile.dateUploaded = new Date();
		newFile.fileName = data.files[0].name
		newFile.fileName = `${environment.server.storageUrl}/${response[0].location}`;

		let selectedItemFiles = {...this.state.selectedItemFiles};
		selectedItemFiles.push(newFile);

		let selectedItem = {...this.state.selectedItem};
		selectedItem.relatedFiles = JSON.stringify(selectedItemFiles);
		// @ts-ignore // Required to be able to change the values
		
		await this.setState({selectedItemFiles,selectedItem});
	}
		
}